import { api } from "./api.ts";

type CreatePolicyArgs = {
  data: unknown;
};

type PatchPolicyArgs = {
  id: string | number;
  data: unknown;
};

type GetPolicyByIdArgs = {
  id: string | number;
  rreId: string | number;
};

type DeletePolicyArgs = {
  id: string | number;
};

export const policyAPI = api.injectEndpoints({
  endpoints: (build) => ({
    createPolicy: build.mutation<unknown, CreatePolicyArgs>({
      query: ({ data }) => ({
        url: `api/v1/policies/`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["RREPolicies"],
    }),
    patchPolicyById: build.mutation<unknown, PatchPolicyArgs>({
      query: ({ id, data }) => ({
        url: `api/v1/policies/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["RREPolicies", "RREPolicy"],
    }),

    getPolicyById: build.query<unknown, GetPolicyByIdArgs>({
      query: ({ id, rreId }) => ({
        url: `api/v1/policies/${id}/`,
        method: "GET",
        params: { rre_id: rreId },
      }),
      providesTags: ["RREPolicy"],
    }),
    deletePolicy: build.mutation<void, DeletePolicyArgs>({
      query: ({ id }) => ({
        url: `api/v1/policies/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["RREPolicies"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useDeletePolicyMutation,
  useCreatePolicyMutation,
  usePatchPolicyByIdMutation,
  useGetPolicyByIdQuery,
} = policyAPI;
